import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { SplashModule } from "../core/components/splash/splash.module";
import { BackgroundModule } from "../core/services/background/background.module";
import { InternetConnectivityModule } from "../core/components/internet-connectivity/internet-connectivity.module";
import { SessionTimeModule } from '../core/services/session-time/session-time.module';
import { BrowserDetectionModule } from "../core/services/browser-detection/browser-detection.module";
import { RecaptchAnalyticsModule } from "./recaptcha.module";

const modules: any[] = [
  BrowserAnimationsModule,
  BrowserModule,
  HttpClientModule,
  SplashModule,
  BackgroundModule,
  InternetConnectivityModule,
  SessionTimeModule,
  BrowserDetectionModule,
  RecaptchAnalyticsModule
];

@NgModule({
  imports: [...modules],
  exports: [...modules],
})
export class CoreModule { }
